import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9a39b542"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "oerder-list-page" }

import { ref } from 'vue'
  import Goods from './goods/index.vue'
  import Vip from './vip/index.vue'
  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

  const active = ref('goods')
  
return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_tabs, {
      modelValue: active.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((active).value = $event)),
      class: "tabs"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, {
          label: "商品订单",
          name: "goods"
        }, {
          default: _withCtx(() => [
            _createVNode(Goods)
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "会员费订单",
          name: "vip"
        }, {
          default: _withCtx(() => [
            _createVNode(Vip)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})